import { InputBlock } from '@coast/schemas/index';
import { useContext } from 'react';
import { ScrollView, TextInput } from 'react-native';
import { MBButton } from '@shared/components/MBButton';
import { MBTextStyles } from '@shared/components/MBText';
import { View } from '@shared/components/View';
import { MBAutosizeTextInput } from '@shared/components/textInput';
import { MBTypographyStyles } from '@shared/components/typography';
import { ColorThemeContext, grid } from '@shared/styles';
import { useIsDesktop } from '@shared/util/hooks';
import { i18n } from '@shared/util/i18n';
import { getTextInputSize, isInputBold } from './input';
import { AnchoredSheetInputBlock } from './inputBottomSheet';

interface Props {
  block: InputBlock;
}

export function MBCardInputBlockTextarea({ block }: Props) {
  const colors = useContext(ColorThemeContext);
  const isDesktop = useIsDesktop();

  return (
    <AnchoredSheetInputBlock<string>
      block={block}
      renderInput={({ value, setValue, onBlur, mode }) => (
        <>
          {isDesktop && (
            <MBAutosizeTextInput
              padding="none"
              autoFocus={mode === 'CREATE' ? block.autoFocus : false}
              value={value}
              onChangeText={setValue}
              onBlur={onBlur}
              // @ts-expect-error -- strict migration
              size={getTextInputSize(block.textStyle)}
              // @ts-expect-error -- strict migration
              bold={isInputBold(block.textStyle)}
              placeholder={block.placeholder}
            />
          )}
          {!isDesktop && (
            <TextInput
              autoFocus={mode === 'CREATE' ? block.autoFocus : false}
              value={value}
              onChangeText={setValue}
              onBlur={onBlur}
              placeholder={block.placeholder}
              multiline
              style={[
                MBTypographyStyles.body1,
                { paddingTop: 0, paddingBottom: 0 },
                // @ts-expect-error -- strict migration
                isInputBold(block.textStyle) && MBTextStyles.bold,
              ]}
            />
          )}
        </>
      )}
      renderEditForm={({ onSave, setValue, value }) => {
        return (
          <>
            <ScrollView style={{ flexGrow: 0 }}>
              <View padding={2}>
                <MBAutosizeTextInput
                  style={{ backgroundColor: colors.backgroundInactive, borderRadius: grid(1) }}
                  onChangeText={setValue}
                  value={value}
                  placeholder={block.placeholder}
                  autoFocus
                  padding="normal"
                />
              </View>
            </ScrollView>
            <View padding={2}>
              <MBButton title={i18n('common.ok')} onPress={onSave} />
            </View>
          </>
        );
      }}
    />
  );
}
